import { defineComponent as _defineComponent } from 'vue'
import { userIsStaff } from '@/helpers/auth';
import KpIcon from '../KpIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCheckDialog',
  props: {
    value: { type: Boolean },
    reasons: null
  },
  emits: ['input', 'publish'],
  setup(__props: any) {




return { __sfc: true,userIsStaff, KpIcon }
}

})